<!--suppress ALL -->
<template>
  <div class="user_list_page">
    <pageTitle />
    <business-group ref="businessGroup" :tableConfig="{...tableConfig}" :formConfig="{...formConfig}">
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input placeholder="请输入姓名/邮箱/手机/国家"
                   v-decorator="['keyword']"
                   style="width:200px;margin-right:10px;vertical-align: middle;" />
        </a-form-item>
        <a-form-item>
          <a-select v-decorator="['jobId']" placeholder="请选择职业" style="width:150px">
            <a-select-option v-for="el in jobList" :value="el.jobId" :key="el.jobId">{{ el.jobName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select placeholder="请选择账号状态" v-decorator="['accountStatus']" style="width:150px">
            <a-select-option v-for="el in accountStatusSelect" :value="el.value" :key="el.value">{{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="() => details(record)">查看</a-button>
        <a-button type="link" @click="() => disable(record)">
          <!--  accountStatus 相反  禁用时显示恢复        -->
          {{ accountStatusMap[record.accountStatus] }}
          <!--            <span v-if="record.accountStatus === 'ENABLED'">禁用</span>-->
          <!--            <span v-if="record.accountStatus === 'DISABLED'">恢复</span>-->
        </a-button>
      </template>
      <template slot="gender" slot-scope="record">
        <span v-text="genderMap[record.gender]" />
      </template>
      <template slot="avatar" slot-scope="record">
        <viewer :images="[record.avatar]">
          <a-avatar :src="record.avatar" size="large" />
        </viewer>
      </template>
      <template slot="accountStatus" slot-scope="record">
        <span v-text="accountStatusMap[record.accountStatus]"></span>
      </template>
    </business-group>



<!--    <div class="page-header">-->
<!--      <my-form @handle-submit="handleSubmit">-->
<!--        <template slot="default" slot-scope="slotProps">-->
<!--          <a-form-item>-->
<!--            <a-input placeholder="请输入姓名/城市/联系邮箱"-->
<!--                     v-decorator="['keyword']"-->
<!--                     style="width:200px;margin-right:10px;vertical-align: middle;" />-->
<!--          </a-form-item>-->
<!--          <a-form-item>-->
<!--            <a-select v-decorator="['jobId']" placeholder="请选择职业" style="width:150px"></a-select>-->
<!--          </a-form-item>-->
<!--          <a-form-item>-->
<!--            <a-select placeholder="请选择账号状态" v-decorator="['accountStatus']" style="width:150px">-->
<!--              <a-select-option v-for="el in accountStatusSelect" :value="el.value" :key="el.value">{{ el.label }}-->
<!--              </a-select-option>-->
<!--            </a-select>-->
<!--          </a-form-item>-->
<!--        </template>-->
<!--      </my-form>-->
<!--    </div>-->
<!--    <div class="page-main">-->
<!--      <my-table :loading="loading" v-bind="{...tableConfig}" @change="handleTableChange">-->
<!--        <template slot="action" slot-scope="text, record, index">-->
<!--          <a-button type="link" @click="() => details(record)">查看</a-button>-->
<!--          <a-button type="link" @click="() => disable(record)">-->
<!--            &lt;!&ndash;  accountStatus 相反  禁用时显示恢复        &ndash;&gt;-->
<!--            {{ accountStatusMap[record.accountStatus] }}-->
<!--            &lt;!&ndash;            <span v-if="record.accountStatus === 'ENABLED'">禁用</span>&ndash;&gt;-->
<!--            &lt;!&ndash;            <span v-if="record.accountStatus === 'DISABLED'">恢复</span>&ndash;&gt;-->
<!--          </a-button>-->
<!--        </template>-->
<!--        <template slot="gender" slot-scope="text, record, index">-->
<!--          <span v-text="genderMap[record.gender]" />-->
<!--        </template>-->
<!--        <template slot="avatar" slot-scope="text, record, index">-->
<!--          <a-avatar size="large" icon="user" />-->
<!--        </template>-->
<!--        <template slot="accountStatus" slot-scope="text, record, index">-->
<!--          <span v-text="accountStatusMap[record.accountStatus]"></span>-->
<!--        </template>-->
<!--      </my-table>-->
<!--    </div>-->
    <a-modal title="用户详情" destroyOnClose :visible="visible" :maskClosable="false" @ok="() => visible = false" @cancel="() => visible = false">
      <a-form-model :modal="detailsInfo" class="info" layout="inline" :label-col="labelCol"
                    :wrapper-col="wrapperCol">
        <a-form-model-item label="姓名">
          <span v-text="detailsInfo.nickname" />
        </a-form-model-item>
        <a-form-model-item label="性别">
          <span v-text="genderMap[detailsInfo.gender]" />
        </a-form-model-item>
        <a-form-model-item label="ID">
          <span v-text="detailsInfo.accountId" />
        </a-form-model-item>
        <a-form-model-item label="职业">
          <span v-text="detailsInfo.jobName" />
        </a-form-model-item>
        <a-form-model-item label="联系邮箱">
          <span v-text="detailsInfo.email" />
        </a-form-model-item>
        <a-form-model-item label="国家">
          <span v-text="detailsInfo.country" />
        </a-form-model-item>
        <a-form-model-item label="注册时间">
          <span v-text="detailsInfo.createTime" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <span v-text="detailsInfo.accountStatus === 'ENABLED'? '已启用': '已禁用'" />
        </a-form-model-item>
      </a-form-model>
      <!--      v-if="detailsInfo.dataSource && detailsInfo.dataSource.length"-->
      <template>
        <p class="title-p">绑定设备数: {{ detailsInfo.dataSource.length || 0 }}</p>
        <a-table :dataSource="detailsInfo.dataSource" :pagination="false" :columns="aAcolumns" rowKey="deviceId">
          <template slot="deviceType" slot-scope="text, record, index">
            <span v-text="deviceTypeMaps[record.deviceType]" />
          </template>
        </a-table>
      </template>
    </a-modal>
  </div>
</template>

<script>
const initial = {
  pageSize: 10,
  current: 1
};

const aAcolumns = [
  {
    title: "设备ID",
    dataIndex: "deviceCode",
    key: "deviceCode",
    align: "center"
  },

  {
    title: "设备类型",
    dataIndex: "deviceType",
    key: "deviceType",
    align: "center",
    scopedSlots: { customRender: "deviceType" }
  },
  {
    title: "绑定时间",
    dataIndex: "bindTime",
    key: "bindTime",
    align: "center"
  }
];
const accountStatusMap = { "ENABLED": "已启用", "DISABLED": "已禁用" };

import moment from "moment";
import { confirm, tips } from "@/utils/util";
import myForm from "@/components/business/Form/myForm";
import myTable from "@/components/business/Table/myTable";
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import mImage from "@/components/business/mImage/mImage";
import {jobs} from "@/api/index/other.js";

export default {
  components: {
    myForm,
    myTable,
    pageTitle,
    businessGroup,
    mImage
  },
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      accountStatusMap,
      accountStatusSelect: Object.keys(accountStatusMap).map(el => ({ value: el, label: accountStatusMap[el] })),
      genderMap: { "FEMALE": "女", "MALE": "男", "SECRET": "保密" },
      deviceTypeMaps: { "WHITE_LIGHT": "白光", "RGB": "RGB", "TWO_COLOR_TEMPERATURE": "双色温","OTHER":'其他' },
      dateFormat: this.$root.$data.dateFormat,
      query: {
        keyword: undefined,	 //搜索关键词：用户昵称、手机号码、邮箱
        startDate: undefined,	// 否 开始日期，格式yyyy-MM-dd
        endDate: undefined,	 // 否结束日期，格式yyyy-MM-dd
        jobId: undefined, // 否 职业ID
        accountStatus: undefined //否  账户状态，可选值：ENABLED（已启用）、DISABLED（已禁用）
      },
      tableConfig: {
        url: 'bluetoothlight/web/account/accounts',
        columns: [
          {
            title: "ID",
            dataIndex: "accountId",
            key: "accountId",
            align: "center",
            width: 80,
          },
          {
            title: "用户头像",
            dataIndex: "avatar",
            key: "avatar",
            align: "center",
            width: 80,
            scopedSlots: { customRender: "avatar" }
          },
          {
            title: "姓名",
            dataIndex: "nickname",
            key: "nickname",
            align: "center",

          },
          {
            title: "性别",
            dataIndex: "gender",
            key: "gender",
            align: "center",
            width: 80,
            scopedSlots: { customRender: "gender" }
          },
          {
            title: "注册时间",
            dataIndex: "createTime",
            key: "createTime",

            align: "center",

          },
          {
            title: "职业",
            dataIndex: "jobName",
            key: "jobName",
            width: 100,
            align: "center",

          },
          {
            title: "国家",
            dataIndex: "country",
            key: "country",
            align: "center"
          },
          {
            title: "手机号",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            width: 120,
            align: "center"
          },
          {
            title: "联系邮箱",
            dataIndex: "email",
            key: "email",
            align: "center",
            width: 180
            //   customRender: (text) => (text / 100).toFixed(2),
          },
          {
            title: "绑定设备数",
            dataIndex: "deviceNum",
            key: "deviceNum",
            width: 120,
            align: "center"
          },
          {
            title: "状态",
            dataIndex: "accountStatus",
            key: "accountStatus",
            scopedSlots: { customRender: "accountStatus" },
            width: 120,
            align: "center"
          },
          {
            title: "操作",
            width: 150,
            scopedSlots: { customRender: "action" },
            align: "center"
          }
        ],
        dataSource: [],
        rowKey: "accountId",
        loading: false,
      },
      formConfig: {
        formShow: true,
        timeShow: true
      },
      visible: false,
      detailsInfo: {
        dataSource: []
      },
      aAcolumns,
      detailsTable: {
        columns: [
          {
            title: "设备ID",
            dataIndex: "deviceId",
            key: "deviceId",
            align: "center",
            width: 80,
            scopedSlots: { customRender: "deviceId" }
          },
          {
            title: "设备唯一标识",
            dataIndex: "deviceCode",
            key: "deviceCode",
            align: "center",
            scopedSlots: { customRender: "deviceCode" }
          },
          {
            title: "设备类型",
            dataIndex: "deviceType",
            key: "deviceType",
            align: "center",
            scopedSlots: { customRender: "deviceType" }
          },
          {
            title: "绑定时间",
            dataIndex: "bindTime",
            key: "bindTime",
            align: "center",
            scopedSlots: { customRender: "bindTime" }
          }

        ],
        dataSource: [],
        rowKey: "deviceId"

      },
      loading: false,
      jobList:[],
    };
  },
  created() {
    //this.getData();
    this.getJob();
  },
  methods: {
    moment,
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },
    handleSubmit(values) {
      this.query = {
        ...this.query,
        ...values
      };
      this.refreshData();
      // this.getData();
    },
    handleClear() {

    },
    getData: async function() {
      const { current, pageSize } = this.tableConfig.pagination || initial;
      this.tableConfig.loading = true;
      const res = await this.$get("bluetoothlight/web/account/accounts", {
        ...this.query,
        pageNo: current,
        pageSize: pageSize
      });
      const resultData = res?.resultData;
      this.tableConfig.dataSource = resultData?.records || [];
      if (resultData) {
        this.tableConfig.dataSource = resultData?.records || [];
        this.setPagination(initial);
      }
      this.tableConfig.loading = false;
    },
    handleTableChange(pagination = {}) {
      const { current, pageSize } = pagination;
      this.setPagination({ current, pageSize });
      this.refreshData();
      // this.getData();
    },
    setPagination(ops = {}) {
      const { pagination } = this.tableConfig;
      this.tableConfig.pagination = { ...pagination, ...ops };
    },
    details: async function(record) {
      if (this.loading) return false;
      const { accountId } = record;
      if (!accountId) return false;
      this.loading = true;
      const res = await this.$get(`bluetoothlight/web/account/accounts/${accountId}`);
      const accountDetail = res?.resultData?.accountDetail || false;
      console.log(res);
      this.loading = false;
      if (!accountDetail) {
        tips(this, false, res?.errorMessage);
        return false;
      }

      this.detailsInfo = {
        ...this.detailsInfo,
        ...accountDetail,
        dataSource: res?.resultData?.devices || []
      };
      this.visible = true;
    },
    disable: async function(record) {
      const { accountId } = record;
      if (!accountId) return false;
      // 相反的显示
      const accountStatus = record?.accountStatus === "ENABLED" ? "DISABLED" : "ENABLED" || "DISABLED";
      const payload = {
        okBack: async () => {
          const res = await this.$put(`bluetoothlight/web/account/accounts/${accountId}/accountstatus`, {
            accountStatus
          });
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            // this.getData();
            this.refreshData();

          }
        },
        title: `是否${accountStatus === "ENABLED" ? "恢复" : "禁用"}该用户`
      };
      confirm(this, payload);
    },
    getJob:async function(){
      let params = {
        pageNo:1,
        pageSize:10
      }
      const {resultStatus,resultData} = await jobs(params);
      if(resultStatus){
        this.jobList = resultData.records;
      } else {
        this.$message.warning('获取失败');
      }
    }
  }

};
</script>
<style lang="less">
.info {

  .ant-row {
    width: 50%;
    margin-right: 0 !important;
    overflow: hidden;
  }
}
</style>

<style lang="less" scoped>
.user_list_page{
  overflow: auto;
}
.user_list_page {
  .header {
    height: 50px;
    font-size: 24px;
    font-weight: 500;
    border-bottom: 1px solid #eee;
    margin-left: 5px;
  }

  .list_button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 10px;
  }
}
</style>
